export default __webpack_public_path__ + "static/media/patent04.afca91ac.png";